
import React from 'react';



type Props = {
  className?: string;
}
export const SharingVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M7 9C8.65685 9 10 7.65685 10 6C10 4.34315 8.65685 3 7 3C5.34315 3 4 4.34315 4 6C4 7.65685 5.34315 9 7 9Z' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M17 15.5C18.6569 15.5 20 14.1569 20 12.5C20 10.8431 18.6569 9.5 17 9.5C15.3431 9.5 14 10.8431 14 12.5C14 14.1569 15.3431 15.5 17 15.5Z' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M7 21C8.65685 21 10 19.6569 10 18C10 16.3431 8.65685 15 7 15C5.34315 15 4 16.3431 4 18C4 19.6569 5.34315 21 7 21Z' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M14.49 10.8699L9.5 7.62988' />
      <path stroke = '#0041A0' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M14.3704 13.9502L9.65039 16.5402' />
    </svg>
  );
};
